import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterM: any = null,
    sceneTextLeaveM: any = null;
export default function M() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const SITE_JP = 'jp';

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterM) {
                    AniContainer.removeScene(sceneTextEnterM);
                    sceneTextEnterM = null;
                }
                if (sceneTextLeaveM) {
                    AniContainer.removeScene(sceneTextLeaveM);
                    sceneTextLeaveM = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterM = AniContainer.create({
                    triggerElement: '.dpu-detail-M .text-info',
                    triggerHook: 1,
                    offset: startH, //isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    duration: 200, //1500, //window.innerHeight - isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterM) {
                    AniContainer.removeScene(sceneTextEnterM);
                    sceneTextEnterM = null;
                }
                if (sceneTextLeaveM) {
                    AniContainer.removeScene(sceneTextLeaveM);
                    sceneTextLeaveM = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-M dpu-detail-section ${css['dpu-detail-M']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <h4 className="subtitle">{t('secM_subtitle')}</h4>
                <h2 className="title">{t('secM_title')}</h2>
                <p className="desc">
                    {t.rich('secM_desc', {
                        w: (text: string) => <span className="white-text">{text}</span>,
                        n: (text: string) => <span className="no-wrap">{text}</span>,
                        sup: (text: string) => <sup className="sup">{text}</sup>,
                    })}
                </p>
            </div>
            <div className="img-box">
                <EFPicture
                    src={'/responsive/picture/delta-pro-ultra/launch/13.jpg'}
                    srcPad={'/responsive/picture/delta-pro-ultra/launch/13_768.jpg'}
                    srcMobile={'/responsive/picture/delta-pro-ultra/launch/13_768.jpg'}
                    alt={t('secM_title')}
                />
            </div>
            {locale === SITE_JP && <p className="tip">{t('secM_tip')}</p>}
        </section>
    );
}
